import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';
import {
  SET_DIALOG_OPEN,
  SET_DIALOG_CLOSED,
  SET_REQUESTED_FOCUS_ID,
} from 'actions/dialog';

const INITIAL_STATE = Immutable({
  isOpen: false,
  requestedFocusId: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case SET_DIALOG_OPEN:
      return state.merge({ isOpen: true });
    case SET_DIALOG_CLOSED:
      return INITIAL_STATE;
    case SET_REQUESTED_FOCUS_ID:
      return state.merge({ requestedFocusId: action.payload });
    default:
      return state;
  }
};
